import { render } from "./SectionCamera.vue?vue&type=template&id=16de1dfa&scoped=true"
import script from "./SectionCamera.vue?vue&type=script&lang=js"
export * from "./SectionCamera.vue?vue&type=script&lang=js"

import "./SectionCamera.vue?vue&type=style&index=0&id=16de1dfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16de1dfa"]])

export default __exports__